import {dd,store,app} from 'systems/imports'

import BaseApi from 'api/BaseApi'
import { normalize, schema, Array } from 'normalizr';

//import { normalize, schema, Array } from 'normalizr';

/**
 */
class DemoRegister extends BaseApi{
  static getClassName(){ return 'DemoRegister' }

  /**
   */
  static provisionalRegister(input){
    return app.make("axios").post(`v1/auth/provisional-register`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }

  /**
   */
  static committalRegister(input){
    return app.make("axios").post(`v1/auth/committal-register`,input)
      .then(({data}) =>{
        return data.data
      })
      .catch(error => {
        let erroRes =  error.response.data.error || "server_error"
        throw Object.assign(new Error(erroRes), { name: erroRes, statusCode: error.response.data.status });
      })
  }



}
export default DemoRegister



// WEBPACK FOOTER //
// ./src/api/DemoRegister.js